import { makeStyles, Theme } from '@material-ui/core';
import useAgenturKontakt from '../kontakt/useAgenturKontakt';
import './menue-icon.css';

const useStyle = makeStyles((theme: Theme) => ({
    menueLine: {
        backgroundColor: theme.palette.text.primary,
    }
}));

const Menue: React.FC = () => {
    const classes = useStyle();
    const { changeVisibleState, renderMainKontakt } = useAgenturKontakt();

    return (<>
        <div id="menue-icon" className={`${renderMainKontakt ? 'open' : undefined}`} onClick={changeVisibleState} color='primary'>
            <span className={classes.menueLine}></span>
            <span className={classes.menueLine}></span>
            <span className={classes.menueLine}></span>
            <span className={classes.menueLine}></span>
        </div>
    </>);
}

export default Menue;